export default function Go_else_if_Statement () {
  return (
    <div>
      <h1>Go_else_if_Statement </h1>
      <p>else if Statement</p>
    </div>
  );
}